import { provincesList, maritalStatusList } from './selectLists';

export const clientTextBox = [
  {
    id: 1,
    value: 'Personal Information',
    label: 'clientTextBox.personalInformation',
  },
  {
    id: 2,
    value: 'General Questions',
    label: 'clientTextBox.generalQuestions',
  },
  { id: 3, value: 'Income', label: 'clientTextBox.income' },
  { id: 4, value: 'Expenses', label: 'clientTextBox.expenses' },
  {
    id: 5,
    value: 'Employment Expenses',
    label: 'clientTextBox.employmentExpenses',
  },
  { id: 6, value: 'Investments', label: 'clientTextBox.investments' },
  {
    id: 7,
    value: 'Authorize a representative',
    label: 'clientTextBox.authorizeARepresentative',
  },
  { id: 8, value: 'Direct Deposit', label: 'clientTextBox.directDeposit' },
];

export const partnerTextBox = [
  {
    id: 1,
    value: 'Partner Information',
    label: 'partnerTextBox.partnerInformation',
  },
  {
    id: 2,
    value: 'Partner General Questions',
    label: 'partnerTextBox.partnerGeneralQuestions',
  },
  { id: 3, value: 'Partner Income', label: 'partnerTextBox.partnerIncome' },
  { id: 4, value: 'Partner Expenses', label: 'partnerTextBox.partnerExpenses' },
  {
    id: 5,
    value: 'Partner Employment Expenses',
    label: 'partnerTextBox.partnerEmploymentExpenses',
  },
  {
    id: 6,
    value: 'Partner Investment',
    label: 'partnerTextBox.partnerInvestment',
  },
  {
    id: 7,
    value: 'Partner Authorize a representative',
    label: 'partnerTextBox.partnerAuthorize',
  },
  {
    id: 8,
    value: 'Partner Direct Deposit',
    label: 'partnerTextBox.partnerDirectDeposit',
  },
];
export const userInputsPersonal = [
  {
    id: 'sin',
    label: 'userInputsPersonal.sin.label',
    type: 'text',
    placeholder: 'userInputsPersonal.sin.placeholder',
    maxLenght: 9,
    minLenght: 9,
    inputMode: 'numeric',
    pattern: '[0-9]+',
  },
  {
    id: 'firstName',
    label: 'userInputsPersonal.firstName.label',
    type: 'text',
    placeholder: 'userInputsPersonal.firstName.placeholder',
  },
  {
    id: 'lastName',
    label: 'userInputsPersonal.lastName.label',
    type: 'text',
    placeholder: 'userInputsPersonal.lastName.placeholder',
  },
  {
    id: 'addressStreet',
    label: 'userInputsPersonal.addressStreet.label',
    type: 'text',
    placeholder: 'userInputsPersonal.addressStreet.placeholder',
  },
  {
    id: 'addressApt',
    label: 'userInputsPersonal.addressApt.label',
    type: 'text',
    placeholder: 'userInputsPersonal.addressApt.placeholder',
    requiredField: false,
  },
  {
    id: 'addressCity',
    label: 'userInputsPersonal.addressCity.label',
    type: 'text',
    placeholder: 'userInputsPersonal.addressCity.placeholder',
  },
  {
    id: 'addressProv',
    label: 'userInputsPersonal.province.label',
    type: 'select',
    listOptions: provincesList,
  },
  {
    id: 'dob',
    label: 'userInputsPersonal.dob.label',
    type: 'date',
  },
  {
    id: 'phone',
    label: 'userInputsPersonal.phone.label',
    type: 'phone',
    placeholder: 'userInputsPersonal.phone.placeholder',
  },
  {
    id: 'postalCode',
    label: 'userInputsPersonal.postalCode.label',
    type: 'text',
    placeholder: 'userInputsPersonal.postalCode.placeholder',
  },
  {
    id: 'maritalStatus',
    label: 'userInputsPersonal.maritalStatus.label',
    type: 'select',
    listOptions: maritalStatusList,
  },
  {
    id: 'numberDependet',
    label: 'userInputsPersonal.numberDependet.label',
    type: 'select',
    listOptions: [
      { id: 0, label: 'numberCount.select', value: 'Select' },
      { id: 1, label: 'numberCount.0', value: '0' },
      { id: 2, label: 'numberCount.1', value: '1' },
      { id: 3, label: 'numberCount.2', value: '2' },
      { id: 4, label: 'numberCount.3', value: '3' },
      { id: 5, label: 'numberCount.4', value: '4' },
      { id: 6, label: 'numberCount.5', value: '5' },
      { id: 7, label: 'numberCount.6', value: '6' },
      { id: 8, label: 'numberCount.7', value: '7' },
      { id: 9, label: 'numberCount.8', value: '8' },
      { id: 10, label: 'numberCount.9', value: '9' },
    ],
  },
  {
    id: 'preferredLanguage',
    label: 'userInputsPersonal.preferredLanguage.label',
    type: 'select',
    listOptions: [
      { id: 0, label: 'languages.select', value: 'Select' },
      { id: 1, label: 'languages.english', value: 'English' },
      { id: 2, label: 'languages.portuguese', value: 'Portuguese' },
    ],
  },
];

export const userInputsPartner = [
  {
    id: 'PartnerSin',
    label: 'userInputsPartner.partnerSin.label',
    type: 'text',
    placeholder: 'userInputsPartner.partnerSin.placeholder',
    maxLenght: 9,
    minLenght: 9,
    pattern: '[0-9]+',
  },
  {
    id: 'PartnerFirstName',
    label: 'userInputsPartner.partnerFirstName.label',
    type: 'text',
    placeholder: 'userInputsPartner.partnerFirstName.placeholder',
  },
  {
    id: 'PartnerLastName',
    label: 'userInputsPartner.partnerLastName.label',
    type: 'text',
    placeholder: 'userInputsPartner.partnerLastName.placeholder',
  },
  {
    id: 'PartnerPhone',
    label: 'userInputsPartner.partnerPhone.label',
    type: 'text',
    placeholder: 'userInputsPartner.partnerPhone.placeholder',
  },
  {
    id: 'PartnerDob',
    label: 'userInputsPartner.partnerDob.label',
    type: 'date',
    placeholder: 'userInputsPartner.partnerDob.placeholder',
  },
  {
    id: 'PartnerNetIncome',
    label: 'userInputsPartner.partnerNetIncome.label',
    type: 'text',
    placeholder: 'userInputsPartner.partnerNetIncome.placeholder',
  },
  {
    id: 'PartnerEmail',
    label: 'userInputsPartner.partnerEmail.label',
    type: 'text',
    placeholder: 'userInputsPartner.partnerEmail.placeholder',
  },
];

export const userInputsGeneralQuestions = [
  {
    id: 'taxTogether',
    label: 'userInputsGeneralQuestions.taxTogether.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
  {
    id: 'firstTaxCanada',
    label: 'userInputsGeneralQuestions.firstTaxCanada.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
  {
    id: 'firstTimeMerits',
    label: 'userInputsGeneralQuestions.firstTimeMerits.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo: 'userInputsGeneralQuestions.firstTimeMerits.dependenceInfo',
  },
  {
    id: 'canadianCitizen',
    label: 'userInputsGeneralQuestions.canadianCitizen.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
  {
    id: 'buyHousePreviousYear',
    label: 'userInputsGeneralQuestions.buyHousePreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
  {
    id: 'addressProvincePreviousYear',
    label: 'userInputsGeneralQuestions.addressProvincePreviousYear.label',
    type: 'select',
    listOptions: provincesList,
  },
  {
    id: 'becameCeasedResidentEntry',
    label: 'userInputsGeneralQuestions.becameCeasedResidentEntry.label',
    type: 'date',
    requiredField: false,
  },
  {
    id: 'becameCeasedResidentDeparture',
    label: 'userInputsGeneralQuestions.becameCeasedResidentDeparture.label',
    type: 'date',
    requiredField: false,
  },

  {
    id: 'previousYearMaritalStatus',
    label: 'userInputsGeneralQuestions.previousYearMaritalStatus.label',
    type: 'select',
    listOptions: maritalStatusList,
  },
  {
    id: 'changedStatusPrevYear',
    label: 'userInputsGeneralQuestions.changedStatusPrevYear.label',
    type: 'date',
    requiredField: false,
  },
  {
    id: 'disabilityClaimAmount',
    label: 'userInputsGeneralQuestions.disabilityClaimAmount.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsGeneralQuestions.disabilityClaimAmount.dependenceInfo',
  },
  {
    id: 'sellHousePreviousYear',
    label: 'userInputsGeneralQuestions.sellHousePreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
  {
    id: 'britishColumbiaRentersCredit',
    label: 'userInputsGeneralQuestions.britishColumbiaRentersCredit.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
  {
    id: 'britishColumbiaRentersCreditText',
    label: 'userInputsGeneralQuestions.britishColumbiaRentersCreditText.label',
    type: 'textarea',
    requiredField: false,
    placeholder:
      'userInputsGeneralQuestions.britishColumbiaRentersCreditText.placeholder',
  },
];

export const userInputsGeneralQuestionsPartner = [
  {
    id: 'PartnerFirstTaxCanada',
    label: 'userInputsGeneralQuestionsPartner.PartnerFirstTaxCanada.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
  {
    id: 'PartnerCanadianCitizen',
    label: 'userInputsGeneralQuestionsPartner.PartnerCanadianCitizen.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
  {
    id: 'PartnerBuyHousePreviousYear',
    label:
      'userInputsGeneralQuestionsPartner.PartnerBuyHousePreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
  {
    id: 'PartnerAddressProvincePreviousYear',
    label:
      'userInputsGeneralQuestionsPartner.PartnerAddressProvincePreviousYear.label',
    type: 'select',
    listOptions: provincesList,
  },
  {
    id: 'PartnerBecameCeasedResidentEntry',
    label:
      'userInputsGeneralQuestionsPartner.PartnerBecameCeasedResidentEntry.label',
    type: 'date',
    requiredField: false,
  },
  {
    id: 'PartnerBecameCeasedResidentDeparture',
    label:
      'userInputsGeneralQuestionsPartner.PartnerBecameCeasedResidentDeparture.label',
    type: 'date',
    requiredField: false,
  },
  {
    id: 'PartnernetIncomeZero',
    label: 'userInputsGeneralQuestionsPartner.PartnernetIncomeZero.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
];

export const userInputsEmployment = [
  {
    id: 'employedPreviousYear',
    label: 'userInputsEmployment.employedPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo: 'userInputsEmployment.employedPreviousYear.dependenceInfo',
  },
  {
    id: 'selfEmployedPreviousYear',
    label: 'userInputsEmployment.selfEmployedPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsEmployment.selfEmployedPreviousYear.dependenceInfo',
    fileUrlDownload:
      'https://firebasestorage.googleapis.com/v0/b/merits-account.appspot.com/o/Self%20Employed-Contractor%202023-2.xlsx?alt=media&token=c8d1cd29-1628-4ccb-9569-598dd9914d37',
  },
  {
    id: 'pensionOrAnyIncomePreviousYear',
    label: 'userInputsEmployment.pensionOrAnyIncomePreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsEmployment.pensionOrAnyIncomePreviousYear.dependenceInfo',
  },
  {
    id: 'maternityLeavePreviousYear',
    label: 'userInputsEmployment.maternityLeavePreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsEmployment.maternityLeavePreviousYear.dependenceInfo',
  },
];

export const userInputsEmploymentPartner = [
  {
    id: 'PartnerEmployedPreviousYear',
    label: 'userInputsEmploymentPartner.PartnerEmployedPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsEmploymentPartner.PartnerEmployedPreviousYear.dependenceInfo',
  },
  {
    id: 'PartnerSelfEmployedPreviousYear',
    label: 'userInputsEmploymentPartner.PartnerSelfEmployedPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsEmploymentPartner.PartnerSelfEmployedPreviousYear.dependenceInfo',
    fileUrlDownload:
      'https://firebasestorage.googleapis.com/v0/b/merits-account.appspot.com/o/Self%20Employed-Contractor%202023-2.xlsx?alt=media&token=c8d1cd29-1628-4ccb-9569-598dd9914d37',
  },
  {
    id: 'PartnerPensionOrAnyIncomePreviousYear',
    label:
      'userInputsEmploymentPartner.PartnerPensionOrAnyIncomePreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsEmploymentPartner.PartnerPensionOrAnyIncomePreviousYear.dependenceInfo',
  },
  {
    id: 'PartnerMaternityLeavePreviousYear',
    label:
      'userInputsEmploymentPartner.PartnerMaternityLeavePreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsEmploymentPartner.PartnerMaternityLeavePreviousYear.dependenceInfo',
  },
];

export const userInputsExpenses = [
  {
    id: 'studyPreviousYear',
    label: 'userInputsExpenses.studyPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo: 'userInputsExpenses.studyPreviousYear.dependenceInfo',
  },
  {
    id: 'medicalExpensesPreviousYear',
    label: 'userInputsExpenses.medicalExpensesPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsExpenses.medicalExpensesPreviousYear.dependenceInfo',
  },
  {
    id: 'donationsPreviousYear',
    label: 'userInputsExpenses.donationsPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo: 'userInputsExpenses.donationsPreviousYear.dependenceInfo',
  },
  {
    id: 'childcarePreviousYear',
    label: 'userInputsExpenses.childcarePreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo: 'userInputsExpenses.childcarePreviousYear.dependenceInfo',
  },
];

export const userInputsEmploymentExpenses = [
  // {
  //   id: 'employmentExpensesFlatMethod',
  //   label: 'userInputsEmploymentExpenses.employmentExpensesFlatMethod.label',
  //   type: 'radio',
  //   listOptions: [
  //     {
  //       id: 1,
  //       label: 'yes',
  //       value: 'Yes',
  //     },
  //     {
  //       id: 2,
  //       label: 'no',
  //       value: 'No',
  //     },
  //   ],
  //   dependenceInfo:
  //     'userInputsEmploymentExpenses.employmentExpensesFlatMethod.dependenceInfo',
  // },
  {
    id: 'employmentExpensesDetailedMethod',
    label:
      'userInputsEmploymentExpenses.employmentExpensesDetailedMethod.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsEmploymentExpenses.employmentExpensesDetailedMethod.dependenceInfo',
  },
  {
    id: 'otherExpenses',
    label: 'userInputsEmploymentExpenses.otherExpenses.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo: 'userInputsEmploymentExpenses.otherExpenses.dependenceInfo',
  },
  {
    id: 'movingExpenses',
    label: 'userInputsEmploymentExpenses.movingExpenses.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsEmploymentExpenses.movingExpenses.dependenceInfo',
  },
];

export const userInputsEmploymentExpensesPartner = [
  {
    id: 'PartnerEmploymentExpensesFlatMethod',
    label:
      'userInputsEmploymentExpensesPartner.PartnerEmploymentExpensesFlatMethod.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsEmploymentExpensesPartner.PartnerEmploymentExpensesFlatMethod.dependenceInfo',
  },
  {
    id: 'PartnerEmploymentExpensesDetailedMethod',
    label:
      'userInputsEmploymentExpensesPartner.PartnerEmploymentExpensesDetailedMethod.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsEmploymentExpensesPartner.PartnerEmploymentExpensesDetailedMethod.dependenceInfo',
  },
  {
    id: 'movingExpenses',
    label: 'userInputsEmploymentExpensesPartner.movingExpenses.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsEmploymentExpensesPartner.movingExpenses.dependenceInfo',
  },
];

export const userInputsExpensesPartner = [
  {
    id: 'PartnerStudyPreviousYear',
    label: 'userInputsExpensesPartner.PartnerStudyPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsExpensesPartner.PartnerStudyPreviousYear.dependenceInfo',
  },
  {
    id: 'PartnerMedicalExpensesPreviousYear',
    label: 'userInputsExpensesPartner.PartnerMedicalExpensesPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsExpensesPartner.PartnerMedicalExpensesPreviousYear.dependenceInfo',
  },
  {
    id: 'PartnerDonationsPreviousYear',
    label: 'userInputsExpensesPartner.PartnerDonationsPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsExpensesPartner.PartnerDonationsPreviousYear.dependenceInfo',
  },
  {
    id: 'PartnerChildcarePreviousYear',
    label: 'userInputsExpensesPartner.PartnerChildcarePreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsExpensesPartner.PartnerChildcarePreviousYear.dependenceInfo',
  },
];

export const userInputsInvestments = [
  {
    id: 'foreignInvestmentExceeded100PreviousYear',
    label:
      'userInputsInvestments.foreignInvestmentExceeded100PreviousYear.label',
    type: 'radio',
    placeholder: 'Describe',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
  {
    id: 'investmentIncomePreviousYear',
    label: 'userInputsInvestments.investmentIncomePreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsInvestments.investmentIncomePreviousYear.dependenceInfo',
  },
  {
    id: 'mutualFundsDividendPreviousYear',
    label: 'userInputsInvestments.mutualFundsDividendPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsInvestments.mutualFundsDividendPreviousYear.dependenceInfo',
  },
  {
    id: 'RRSPPreviousYear',
    label: 'userInputsInvestments.RRSPPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo: 'userInputsInvestments.RRSPPreviousYear.dependenceInfo',
  },
  {
    id: 'FHSAPreviousYear',
    label: 'userInputsInvestments.FHSAPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo: 'userInputsInvestments.FHSAPreviousYear.dependenceInfo',
  },
  {
    id: 'foreignInvestmentHousePreviousYear',
    label: 'userInputsInvestments.foreignInvestmentHousePreviousYear.label',
    type: 'textarea',
    requiredField: false,
    placeholder:
      'userInputsInvestments.foreignInvestmentHousePreviousYear.placeholder',
  },
  {
    id: 'foreignInvestmentHousePreviousYearDocument',
    label:
      'userInputsInvestments.foreignInvestmentHousePreviousYearDocument.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsInvestments.foreignInvestmentHousePreviousYearDocument.dependenceInfo',
  },
  {
    id: 'foreignInvestmentHouseFileUploadPreviousYear',
    label:
      'userInputsInvestments.foreignInvestmentHouseFileUploadPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsInvestments.foreignInvestmentHouseFileUploadPreviousYear.dependenceInfo',
    fileUrlDownload:
      'https://firebasestorage.googleapis.com/v0/b/merits-account.appspot.com/o/Rental%20Property.xlsx?alt=media&token=c56c26de-62b9-4af1-94fa-39027ccc83ed',
  },
];

export const userInputsInvestmentsPartner = [
  {
    id: 'PartnerForeignInvestmentExceeded100PreviousYear',
    label:
      'userInputsInvestmentsPartner.PartnerForeignInvestmentExceeded100PreviousYear.label',
    type: 'radio',
    placeholder:
      'userInputsInvestmentsPartner.PartnerForeignInvestmentExceeded100PreviousYear.placeholder',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
  {
    id: 'PartnerInvestmentIncomePreviousYear',
    label:
      'userInputsInvestmentsPartner.PartnerInvestmentIncomePreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsInvestmentsPartner.PartnerInvestmentIncomePreviousYear.dependenceInfo',
  },
  {
    id: 'PartnerMutualFundsDividendPreviousYear',
    label:
      'userInputsInvestmentsPartner.PartnerMutualFundsDividendPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsInvestmentsPartner.PartnerMutualFundsDividendPreviousYear.dependenceInfo',
  },
  {
    id: 'PartnerRRSPPreviousYear',
    label: 'userInputsInvestmentsPartner.PartnerRRSPPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsInvestmentsPartner.PartnerRRSPPreviousYear.dependenceInfo',
  },
  {
    id: 'PartnerFHSAPreviousYear',
    label: 'userInputsInvestmentsPartner.PartnerFHSAPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsInvestmentsPartner.PartnerFHSAPreviousYear.dependenceInfo',
  },
  {
    id: 'PartnerForeignInvestmentHousePreviousYear',
    label:
      'userInputsInvestmentsPartner.PartnerForeignInvestmentHousePreviousYear.label',
    type: 'textarea',
    placeholder:
      'userInputsInvestmentsPartner.PartnerForeignInvestmentHousePreviousYear.placeholder',
    requiredField: false,
  },
  {
    id: 'PartnerForeignInvestmentHouseFileUploadPreviousYear',
    label:
      'userInputsInvestmentsPartner.PartnerForeignInvestmentHouseFileUploadPreviousYear.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
    uploadFileDependence: 'Yes',
    dependenceInfo:
      'userInputsInvestmentsPartner.PartnerForeignInvestmentHouseFileUploadPreviousYear.dependenceInfo',
    fileUrlDownload:
      'https://firebasestorage.googleapis.com/v0/b/merits-account.appspot.com/o/Rental%20Property.xlsx?alt=media&token=c56c26de-62b9-4af1-94fa-39027ccc83ed',
  },
];

export const userAuthorize = [
  {
    id: 'AuthorizeRepresentative',
    label: 'userAuthorize.AuthorizeRepresentative.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
];

export const userAuthorizePartner = [
  {
    id: 'PartnerAuthorizeRepresentative',
    label: 'userAuthorizePartner.PartnerAuthorizeRepresentative.label',
    type: 'radio',
    listOptions: [
      {
        id: 1,
        label: 'yes',
        value: 'Yes',
      },
      {
        id: 2,
        label: 'no',
        value: 'No',
      },
    ],
  },
];

export const userInputDependants = [
  {
    id: 'DependantSin',
    label: 'userInputDependants.DependantSin.label',
    type: 'text',
    placeholder: 'userInputDependants.DependantSin.placeholder',
    maxLenght: 9,
    minLenght: 9,
    pattern: '[0-9]+',
  },
  {
    id: 'DependantFirstName',
    label: 'userInputDependants.DependantFirstName.label',
    type: 'text',
    placeholder: 'userInputDependants.DependantFirstName.placeholder',
    requiredField: true,
  },
  {
    id: 'DependantLastName',
    label: 'userInputDependants.DependantLastName.label',
    type: 'text',
    placeholder: 'userInputDependants.DependantLastName.placeholder',
    requiredField: true,
  },
  {
    id: 'DependantRelation',
    label: 'userInputDependants.DependantRelation.label',
    type: 'text',
    placeholder: 'userInputDependants.DependantRelation.placeholder',
    requiredField: true,
  },
  {
    id: 'DependantBod',
    label: 'userInputDependants.DependantBod.label',
    type: 'date',
    requiredField: true,
  },
];

export const userBankInf = [
  {
    id: 'bankTransit',
    label: 'userBankInf.bankTransit.label',
    type: 'number',
    placeholder: 'userBankInf.bankTransit.placeholder',
    requiredField: false,
  },
  {
    id: 'bankInstitution',
    label: 'userBankInf.bankInstitution.label',
    type: 'number',
    placeholder: 'userBankInf.bankInstitution.placeholder',
    requiredField: false,
  },
  {
    id: 'bankAccNumber',
    label: 'userBankInf.bankAccNumber.label',
    type: 'number',
    placeholder: 'userBankInf.bankAccNumber.placeholder',
    requiredField: false,
  },
];

export const userBankInfPartner = [
  {
    id: 'PartnerbankTransit',
    label: 'userBankInfPartner.PartnerbankTransit.label',
    type: 'number',
    placeholder: 'userBankInfPartner.PartnerbankTransit.placeholder',
    requiredField: false,
  },
  {
    id: 'PartnerbankInstitution',
    label: 'userBankInfPartner.PartnerbankInstitution.label',
    type: 'number',
    placeholder: 'userBankInfPartner.PartnerbankInstitution.placeholder',
    requiredField: false,
  },
  {
    id: 'PartnerbankAccNumber',
    label: 'userBankInfPartner.PartnerbankAccNumber.label',
    type: 'number',
    placeholder: 'userBankInfPartner.PartnerbankAccNumber.placeholder',
    requiredField: false,
  },
];
